import Color from "color";
import { mapValues } from "lodash/fp.js";
import { createContext, createElement, useContext } from "react";
const enrichTheme = (theme) => {
  const colors = mapValues((color) => {
    return (intensity = 1) => {
      return Color(color).mix(Color("white"), 1 - intensity).hex();
    };
  }, theme.colorPalette);
  return {
    ...theme,
    colors
  };
};
const EnrichedThemeContext = createContext(null);
const ThemeProvider = (props) => {
  const { children, theme } = props;
  return createElement(EnrichedThemeContext.Provider, { value: enrichTheme(theme) }, children);
};
const useThemeFromContext = () => {
  const theme = useContext(EnrichedThemeContext);
  if (!theme) {
    throw new Error("No theme provided. Components using useThemeFromContext must be descendants of ThemeProvider.");
  }
  return theme;
};
export {
  ThemeProvider,
  enrichTheme,
  useThemeFromContext
};
